import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { Loader2 } from "lucide-react";

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-[#EEF2F6]">
        <div className="flex flex-col items-center gap-4">
          <Logo />
          <Loader2 className="animate-spin text-brand" size={20} />
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
